type BaseModalProps = {
  title?: string;
  onClose: () => void;
  closeOnBackdrop?: boolean;
  children: React.ReactNode;
  footer?: React.ReactNode;
};

export function BaseModal({
  title,
  onClose,
  closeOnBackdrop = true,
  children,
  footer,
}: BaseModalProps) {
  return (
    <div
      className="fixed inset-0 z-[9999] bg-black/40 flex items-center justify-center"
      onMouseDown={(e) => {
        if (!closeOnBackdrop) return;
        if (e.target === e.currentTarget) onClose();
      }}
    >
      <div className="relative bg-white rounded-xl w-[90%] md:w-[70%] h-[90vh] overflow-hidden flex flex-col">
        {/* Header */}
        <header className="shrink-0 bg-gray-50 w-full py-6 px-6 sm:px-10 flex items-center justify-between">
          <div className="w-8" />
          <h1 className="text-xl sm:text-3xl text-center font-bold tracking-tight text-gray-900">
            {title ?? ""}
          </h1>
          <button
            className="w-8 h-8 flex items-center justify-center"
            onClick={onClose}
            aria-label="close"
            type="button"
          >
            ✕
          </button>
        </header>

        {/* Body (scroll) */}
        <section className="flex-1 min-h-0 overflow-y-auto bg-white p-4 sm:p-8">{children}</section>

        {/* Footer (optional) */}
        {footer ? (
          <footer className="shrink-0 border-t bg-white px-4 sm:px-8 py-4">{footer}</footer>
        ) : null}
      </div>
    </div>
  );
}
